<div *ngIf="!isIE" class="wrapper" [class.is-printing]="printService.isPrinting">
    <div class="wrapper__alert">
        <app-alert></app-alert>
    </div>
    <div *ngIf="(loggedIn$ | async)"
        class="sidebar"
        [@collapseSidebarState]="!(sidebarCollapsed$ | async) ? 'default' : 'collapsed'">
        <div class="sidebar__brand">
            <a class="navbar-brand p-2" [routerLink]="['/']">
                <img [src]="(sidebarCollapsed$ | async) ? noTxtLogo : logo" class="logo">
            </a>
            <div *ngIf="!env.production" class="sidebar__environment">{{ env.envName }} {{ env.version }}</div>
        </div>
        <div>
            <app-sidebar
                [currentClient]="currentClient$ | async"
                [currentUser]="currentUser$ | async"
                [officeName]="officeName$ | async"
                [sidebarCollapsed]="sidebarCollapsed$ | async"
                [clientCases]="clientCases$ | async"
                [recentClients]="recentClients$ | async"
                [navigationUrl]="navigationUrl"
                (openStamarkiv)="openStamarkiv($event)"
                (openClientCase)="openClientCase($event)"
                (toggleSidebar)="toggleSidebar($event)"
            ></app-sidebar>
        </div>
    </div>

    <div class="right">
        <div
            *ngIf="(loggedIn$ | async)"
            class="topbar"
            [@collapseRightState]="!(loggedIn$ | async) ? 'none' : (sidebarCollapsed$ | async) ? 'collapsed' : 'default'">
            <app-header
                [currentUser]="currentUser$ | async"
                [isSupporter]="isSupporter$ | async"
                [isFaglig]="isFaglig$ | async"
                [currentClient]="currentClient$ | async"
                [menu]="menu$ | async"
                [sidebarCollapsed]="sidebarCollapsed$ | async"
                [officeSettings]="officeSettings$ | async"
                (methodCall)="modalsService.methodCall($event)"
                (toggleSidebar)="toggleSidebar($event)">
            </app-header>
        </div>
        <div class="content" [@collapseRightState]="!(loggedIn$ | async) ? 'none' : (sidebarCollapsed$ | async) ? 'collapsed' : 'default'">
            <div class="container-fluid pt-2">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>

<ng-container #statistikModalHost></ng-container>

<div *ngIf="isIE">
    <h1>QWM kan ikke benyttes i Internet Explorer!</h1><br>
    Benyt venligst Google Chrome eller en anden moderne browser.<br>
    Funktioner der stadig kræver Internet Explorer, åbner QWM nu selv i Internet Explorer.
</div>

<router-outlet name="print"></router-outlet>
